export default __webpack_public_path__ + "roboto-latin-300.woff2";